/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_Min_Spend_Input_LabelInputs */

const vi_shop_tier_min_spend_input_label = /** @type {(inputs: Shop_Tier_Min_Spend_Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiêu tối thiểu (đ)`)
};

/**

* @param {Shop_Tier_Min_Spend_Input_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_min_spend_input_label = /** @type {((inputs?: Shop_Tier_Min_Spend_Input_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Min_Spend_Input_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_min_spend_input_label(inputs)
});